export enum OneTimePremiumPlan {
  oneWeek = 'semanal',
  oneMonth = 'mensual',
  oneYear = 'anual',
}

export enum OneTimePremiumPlanDto {
  oneWeek = 'ParticularOneWeek',
  oneMonth = 'ParticularOneMonth',
  oneYear = 'ParticularOneYear',
}

export const oneTimePlanOptions = {
  price: {
    [OneTimePremiumPlan.oneWeek]: 399,
    [OneTimePremiumPlan.oneMonth]: 999,
    [OneTimePremiumPlan.oneYear]: 2999,
  },
  label: {
    [OneTimePremiumPlan.oneWeek]: '1 semana',
    [OneTimePremiumPlan.oneMonth]: '1 mes',
    [OneTimePremiumPlan.oneYear]: '1 año',
  },
}

export interface CustomerDetailsInfoPremiumDto {
  selectedPlan: string
  endDate: Date | string
}

export interface CustomerDetailsInfoPremium {
  selectedPlan: string
  endDate: Date | string
}

export interface InfoDiscountCoupon {
  discountPercent: number
  priceWithDiscount: number
}

export interface InfoDiscountCouponDto {
  discountPercent: number
  priceWithDiscount: number
}

export interface CouponInfoData {
  couponCode: string
  validPlan: string[]
  maxRedeems: string
  timeLimit: string | Date
  discountPercent: string
  includesLongTerm: boolean
}

export interface CouponInfoDataDto {
  couponCode: string
  validPlan: string[]
  maxRedeems: number
  timeLimit: string | Date
  discountPercent: number
  includesLongTerm: boolean
}



// WEBPACK FOOTER //
// ./src/domain/model/premium/premium.model.ts